import { NamiProductDetails } from "@namiml/web-sdk";

export const productDetails: NamiProductDetails[] = [
  {
    name: 'POC Base Monthly',
    description: 'POC Base Monthly Subscription',
    product_ref_id: 'poc_base_monthly',
    product_type: 'subscription',
    subscription_period: {
      type: 'month',
      count: 1
    },
    offers: [
      {
        price: 9.99,
        currency: 'USD',
        offer_type: 'default',
      },
      {
        price: 13.54,
        currency: 'CAD',
        offer_type: 'default',
      }
    ]
  },
  {
    name: 'POC Premium Monthly',
    description: 'POC Premium Monthly Subscription',
    product_ref_id: 'poc_premium_monthly',
    product_type: 'subscription',
    subscription_period: {
      type: 'month',
      count: 1
    },
    offers: [
      {
        price: 14.99,
        currency: 'USD',
        offer_type: 'default',
      },
      {
        price: 20.32,
        currency: 'CAD',
        offer_type: 'default',
      }
    ]
  },
  {
    name: 'POC Base Annual',
    product_ref_id: 'poc_base_annual',
    product_type: 'subscription',
    subscription_period: {
      type: 'year',
      count: 1
    },
    offers: [
      {
        price: 99.99,
        currency: 'USD',
        offer_type: 'promo',
        promo_period: {
          type: 'year',
          count: 1
        },
        promo_price: {
          price: 79.99,
          currency: 'USD'
        }
      },
      {
        offer_ref_id: "poc_base_annual_offer1",
        price: 99.99,
        currency: 'USD',
        offer_type: 'default',
      },
      {
        offer_ref_id: "poc_base_annual_offer1",
        price: 135.52,
        currency: 'CAD',
        offer_type: 'default',
      }
    ]
  },
  {
    name: 'POC Premium Annual',
    product_ref_id: 'poc_premium_annual',
    product_type: 'subscription',
    subscription_period: {
      type: 'year',
      count: 1
    },
    offers: [
      {
        price: 199.99,
        currency: 'USD',
        offer_type: 'promo',
        promo_period: {
          type: 'year',
          count: 1
        },
        promo_price: {
          price: 159.99,
          currency: 'USD'
        }
      },
      {
        price: 199.99,
        currency: 'USD',
        offer_type: 'default',
      },
      {
        price: 271.06,
        currency: 'CAD',
        offer_type: 'default',
      }
    ]
  },
  {
    name: 'NFL+ Monthly [SB]',
    description: 'NFL+ Monthly Subscription',
    product_ref_id: 'nfl-5',
    product_type: 'subscription',
    subscription_period: {
      type: 'month',
      count: 1
    },
    offers: [
      {
        price: 6.99,
        currency: 'USD',
        offer_type: 'default',
      },
    ]
  },
  {
    name: 'NF:+ Premium Monthly [SB]',
    description: 'NFL+ Premium Monthly Subscription',
    product_ref_id: 'nfl-4',
    product_type: 'subscription',
    subscription_period: {
      type: 'month',
      count: 1
    },
    offers: [
      {
        price: 14.99,
        currency: 'USD',
        offer_type: 'default',
      },
    ]
  },
  {
    name: 'NFL+ Annual [SB]',
    product_ref_id: 'nfl-1',
    product_type: 'subscription',
    subscription_period: {
      type: 'year',
      count: 1
    },
    offers: [
      {
        price: 49.99,
        currency: 'USD',
        offer_type: 'default',
      },
    ]
  },
  {
    name: 'NFL+ Premium Annual [SB]',
    product_ref_id: 'nfl-6',
    product_type: 'subscription',
    subscription_period: {
      type: 'year',
      count: 1
    },
    offers: [
      {
        price: 99.99,
        currency: 'USD',
        offer_type: 'default',
      }
    ]
  }
]
